<template>
	<div
		class="absolute top-0 left-0 w-full h-full bg-black block z-[11000] p-8 transition-colors duration-75"
		:style="{ '--tw-bg-opacity': output }"
	>
		<Transition
			name="modal"
			appear
		>
			<div
				class="sticky top-5 bg-white rounded max-h-[90vh] mx-auto flex flex-col transition-all"
				:class="{ 'h-full': fillScreen, 'h-min': !fillScreen, 'w-min': !fillScreenWidth }"
			>
				<div class="w-full flex items-center p-4 border-b">
					<slot name="title">
						<h3
							v-if="title"
							class="text-xl font-semibold"
							:class="titleClass"
							v-text="title"
						/>
					</slot>

					<AppButton icon-only class="ml-auto" icon="close" @click="onCancel"></AppButton>
				</div>
				<div
					v-if="visible"
					class="w-fit h-min mx-auto flex flex-row flex-wrap items-start grow shrink overflow-hidden overflow-y-auto"
					:class="modalClasses"
				>
					<slot/>
				</div>
				<slot name="footer">
					<div
						class="p-2 h-fit self-end w-full relative flex flex-row gap-2 items-end justify-end border-t border-dashed"
					>
						<AppButton @click="onCancel">
							Annuleren
						</AppButton>
						<slot name="footer-content"></slot>
					</div>
				</slot>
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import { TransitionPresets } from "@vueuse/core";

const visible = ref(false);
const opacity = ref(0);
const output = useTransition(opacity, {
	duration: 75,
	transition: TransitionPresets.easeInOutCubic,
});

onMounted(() => {
	opacity.value = 0.5;
	visible.value = true;
});

const props = withDefaults(
	defineProps<{
		modalClass?: string;
		titleClass?: string;
		title?: string;
		bodyScroll?: boolean;
		fillScreen?: boolean;
		fillScreenWidth?: boolean;
	}>(),
	{
		modalClass: "",
		titleClass: "",
		title: "",
		bodyScroll: true,
		fillScreen: false,
		fillScreenWidth: false,
	},
);

function onCancel() {
	emit("cancel");
}

const emit = defineEmits<{
	(e: "confirm", value: string[]): void;
	(e: "cancel"): void;
}>();

const modalClasses = computed(() => {
	const classes: string[] = props.modalClass?.split(" ") ?? [];

	if (props.bodyScroll) {
		classes.push("overflow-y-auto");
		classes.push("scrollbar-thin");
		classes.push("max-h-[90%]");
	}

	return classes;
});
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
	transition: all .2s ease-in;
}

.modal-enter-from {
	opacity: 0;
	transform: scale(0.8);
}

.modal-leave-to /* .fade-leave-active below version 2.1.8 */
{
	opacity: 0;
	transform: scale(0.8);
}
</style>
